export default "__VITE_ASSET__DMqf20KK__"